import { render, staticRenderFns } from "./TopicSlider.vue?vue&type=template&id=31f6df42&"
import script from "./TopicSlider.vue?vue&type=script&lang=js&"
export * from "./TopicSlider.vue?vue&type=script&lang=js&"
import style0 from "./TopicSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports